import React from 'react';
import { motion } from 'framer-motion';
import { CONTACT_INFO } from '@utils/constants';

const CTA = ({ openBooking }) => {
  return (
    <section className="py-24 bg-gradient-to-br from-indigo-600 to-violet-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-300 rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Career?
        </h2>
        <p className="text-xl text-indigo-100 mb-8">
          Join our next cohort of 5-7 clients. Spots fill fast.
        </p>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => openBooking()}
          className="bg-white text-indigo-600 px-10 py-5 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-white/25 transition-shadow"
        >
          Book Your Consultation Now
        </motion.button>
        <p className="mt-6 text-indigo-200 text-sm">
          Free {CONTACT_INFO.consultationDuration} strategy call • Available {CONTACT_INFO.availability}
        </p>
      </div>
    </section>
  );
};

export default CTA;
